import { render } from "./ProductWithFlagOverlay.vue?vue&type=template&id=70518740&scoped=true"
import script from "./ProductWithFlagOverlay.vue?vue&type=script&lang=js"
export * from "./ProductWithFlagOverlay.vue?vue&type=script&lang=js"

import "./ProductWithFlagOverlay.vue?vue&type=style&index=0&id=70518740&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70518740"]])

export default __exports__